import { syncJobsFromPeople } from '../sync/jobsSync';
import { returnUnusedTools } from './toolsManager';
import type { PersonJob, Settlement } from '../types';

export function assignJob(settlement: Settlement, job: PersonJob): boolean {
    const person = settlement.people.find((candidate) => !candidate.job);
    if (!person) return false;
    person.job = job;
    syncJobsFromPeople(settlement);
    return true;
}

export function unassignJob(settlement: Settlement, job: PersonJob): boolean {
    const index = settlement.people.findIndex((candidate) => candidate.job === job);
    if (index < 0) return false;
    settlement.people[index].job = null;
    syncJobsFromPeople(settlement);
    returnUnusedTools(settlement);
    return true;
}
